import {
  getPageCategoriesQuery,
  getPagePreviewCategoriesQuery,
} from '@redlink/services';

export const freshCache = ({ isEditMode, id, pageName, type }) => (
  cache,
  { data }
) => {
  freshCategories({ cache, data, isEditMode, id, type });
  freshPreviewCategories({ cache, data, isEditMode, id, pageName, type });
};

const freshPreviewCategories = ({
  cache,
  data,
  isEditMode,
  id,
  pageName,
  type,
}) => {
  const freshData = !isEditMode ? data.NewCategory : data.EditCategory;

  try {
    let { CategoriesPreview: oldData = [] } = cache.readQuery({
      query: getPagePreviewCategoriesQuery,
      variables: { pageName, type },
    });

    cache.writeQuery({
      query: getPagePreviewCategoriesQuery,
      data: {
        CategoriesPreview: getFreshCategories({
          isEditMode,
          id,
          oldData,
          freshData,
        }),
      },
      variables: { pageName, type },
    });
  } catch (e) {}
};

const freshCategories = ({ cache, data, isEditMode, id, type }) => {
  const freshData = !isEditMode ? data.NewCategory : data.EditCategory;

  let { Categories: oldData } = cache.readQuery({
    query: getPageCategoriesQuery,
    variables: { type },
  });

  cache.writeQuery({
    query: getPageCategoriesQuery,
    data: {
      Categories: getFreshCategories({ isEditMode, id, oldData, freshData }),
    },
    variables: { type },
  });
};

const getFreshCategories = ({ isEditMode, id, oldData, freshData }) => {
  if (isEditMode) {
    const editedItemIndex = oldData.findIndex((p) => p.id === id);
    oldData = [
      ...oldData.slice(0, editedItemIndex),
      freshData,
      ...oldData.slice(editedItemIndex + 1),
    ];
  } else {
    oldData = [...oldData, freshData];
  }

  return oldData;
};

export const freshCacheForRemoveItem = ({ pageName, type }) => (
  cache,
  {
    data: {
      RemoveCategory: id,
    },
  }
) => {
  freshCategoriesRemove({ cache, id, type });
  freshPreviewCategoriesRemove({
    cache,
    id,
    pageName,
    type,
  });
};

const freshCategoriesRemove = ({ cache, id, type }) => {
  let { Categories: oldData } = cache.readQuery({
    query: getPageCategoriesQuery,
    variables: { type },
  });

  cache.writeQuery({
    query: getPageCategoriesQuery,
    data: {
      Categories: [...oldData.filter((p) => p.id !== id)],
    },
    variables: { type },
  });
};

const freshPreviewCategoriesRemove = ({ cache, id, pageName, type }) => {
  try {
    let { CategoriesPreview: oldData } = cache.readQuery({
      query: getPagePreviewCategoriesQuery,
      variables: { pageName, type },
    });

    cache.writeQuery({
      query: getPagePreviewCategoriesQuery,
      data: {
        CategoriesPreview: [...oldData.filter((p) => p.id !== id)],
      },
      variables: { pageName, type },
    });
  } catch (e) {}
};
